// Campaign API. Goes through the shared client so the user's token (or SSO
// cookie) is attached; the old bare fetch() calls 401'd for Bearer and
// break-glass users.
import { apiV1 } from './client';

const data = async (promise) => (await promise).data;

export const campaignsApi = {
  list: (params = {}) => data(apiV1.get('/campaigns/', { params })),
  // Totals over every campaign in the caller's scope (not a page of 50).
  stats: () => data(apiV1.get('/campaigns/stats')),
  get: (id) => data(apiV1.get(`/campaigns/${id}`)),
  // The campaign's own linked assets.
  assets: (id) => data(apiV1.get(`/campaigns/${id}/assets`)),
  create: (body) => data(apiV1.post('/campaigns/', body)),
  update: (id, body) => data(apiV1.put(`/campaigns/${id}`, body)),
  delete: (id) => data(apiV1.delete(`/campaigns/${id}`)),
  activate: (id) => data(apiV1.post(`/campaigns/${id}/activate`)),
  pause: (id) => data(apiV1.post(`/campaigns/${id}/pause`)),
  addAsset: (id, assetType, assetId) =>
    data(apiV1.post(`/campaigns/${id}/assets`, { asset_type: assetType, asset_id: assetId })),
  removeAsset: (id, assetType, assetId) =>
    data(apiV1.delete(`/campaigns/${id}/assets`, { data: { asset_type: assetType, asset_id: assetId } })),
  refreshStats: (id) => data(apiV1.post(`/campaigns/${id}/refresh-stats`)),
  getPerformance: (id) => data(apiV1.get(`/campaigns/${id}/performance`)),
  getStatusOptions: () => data(apiV1.get('/campaigns/options/statuses')),
  getGoalOptions: () => data(apiV1.get('/campaigns/options/goals')),
};

export default campaignsApi;
